// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
      termKey: 'q',
      suggestionWidth: 650,
      suggestionPosition: 'left',
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};
  

  /* start-boost-custom */
  /* #boost-78984: Fix Instant Search */
  jQ('.search-button').on('click',function() {
    setTimeout(function() {
      boostPFS.initSearchBox();
      jQ('.boost-pfs-search-box').focus();
    }, 1000)  
  });
  
  var bindEvents = InstantSearchMobile.prototype.bindEvents;
  
  InstantSearchMobile.prototype.bindEvents = function() {
      bindEvents.call(this);
      var buttonClass = '.site-nav--mobile .search-button' /* set the search magnifier selector*/

      var self = this;

      var clone = jQ(buttonClass).clone();
      clone.attr('href', 'javascript:void(0)');

      clone.on('click', function(e) {
        e.stopPropagation();
        e.preventDefault();
        self.openSuggestionMobile()
      });

      jQ(buttonClass).replaceWith(clone);
  }
  /* end-boost-custom */
})();